import {kuiset} from '../utils/kuiset';
import {register} from '../modules/eventMap';

import {each, findAll, offClickOutside, onClickOutside} from '../utils';

const closeAllDropdowns = () => {
    const openTriggers = findAll(
        '[kui-dropdown-trigger="true"][aria-expanded="true"]'
    );
    if (openTriggers) each(openTriggers, toggleDropdown);
};

const closeOtherDropdowns = (button) => {
    /* Temp nasty hack to allow nested dropdowns */
    const parentDropdown = button.closest('[kui-dropdown-content="true"]');

    const openTriggers = findAll(
        '[kui-dropdown-trigger="true"][aria-expanded="true"]'
    );
    const openDropdowns = findAll('.is-active[kui-dropdown-content="true"]');

    if (openTriggers)
        each(openTriggers, (button) => {
            if (
                !parentDropdown?.id ||
                button.getAttribute('aria-controls') !== parentDropdown?.id
            ) {
                button.setAttribute('aria-expanded', false);
            }
        });

    if (openDropdowns)
        each(openDropdowns, (d) => {
            if (!parentDropdown?.id || d.id !== parentDropdown?.id) {
                d.classList.remove('is-active');
            }
        });
};

const handleClickOutside = () => {
    closeAllDropdowns();
};

const handleEscape = (e) => {
    if (e.key === 'Escape') closeAllDropdowns();
};

const onPressEscape = () => {
    document.body.addEventListener('keyup', handleEscape);
};

const offPressEscape = () => {
    document.body.removeEventListener('keyup', handleEscape);
};

const toggleDropdown = (button) => {
    const {dropdownControls} = kuiset(button);
    const isExpanded = button.getAttribute('aria-expanded') === 'true' || false;
    const clickOutside = isExpanded ? offClickOutside : onClickOutside;
    const pressEscape = isExpanded ? offPressEscape : onPressEscape;
    const dropdown = document.getElementById(dropdownControls);
    const isNewDropdown = dropdown.classList.contains('kui-dropdown-menu');
    const firstFocusableElement = dropdown.querySelector(
        'a[href]:first-child, button[type="submit"]'
    );

    closeOtherDropdowns(button);
    button.setAttribute('aria-expanded', !isExpanded);
    if (!isExpanded) {
        dropdown.classList.add('is-active');

        if (isNewDropdown) {
            firstFocusableElement.focus({focusVisible: true});
        }
    }
    clickOutside('[kui-dropdown]', handleClickOutside);
    pressEscape();
};

const dropdown = () => {
    register('dropdown', {
        toggle: toggleDropdown
    });
};

export {dropdown};
